module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace-w540.f34d1aae.webp";